import React, { useEffect, useState } from 'react'
import './depth-chart-container.styles.scss';

import { positions } from '@/utils/positions';
import { levels } from '@/utils/levels';
import { RandomString } from '@/utils/randomString';

// College players show their class (FR..SR); pro players show their age.
function classLabel(p) {
    return p.year ? levels[p.year - 1].short : `Age ${p.age}`;
}

// showHidden: admin tools only. Managers never receive hidden traits
// (see @shared/visibility.js), and this keeps the UI from implying them.
const DepthChartContainer = ({
    players,
    depth,
    changeDepth,
    showHidden = false,
}) => {

    const chemLabel = (p) => showHidden && p.chemistry !== undefined ? ` - Chem ${p.chemistry}` : '';

    const [ sortedPlayers, setSortedPlayers ] = useState([]); 

    useEffect(() => {
        if (!players) return;
        let sorted = Object.values(players)
        .sort((a,b) => 
            a.pos1 > b.pos1 
            ? 1 
            : 
            (
                a.pos1 === b.pos1
                ?
                (
                    a.overall < b.overall
                    ? 1
                    : -1
                )
                : -1
            )
        )
        setSortedPlayers(sorted);
    }, [players])

    function changeDepthChart(pos, num, playerId) {
        let tempDepth = {...depth}
        let replacedId = tempDepth[pos.id + '_' + num];
        let replacedPlayer = players[replacedId];
        console.log(replacedPlayer);
        let newPosition;
        for (let id of Object.keys(depth)) {
            let playerFromChart = tempDepth[id];
            if (playerFromChart === playerId) {
                newPosition = id;
                break;
            }
        }
        if (
            replacedPlayer && 
            (
                positions[replacedPlayer.pos1 - 1].id === pos.id
            )
        ) {
            tempDepth[newPosition] = replacedId;
        }
        tempDepth[pos.id + '_' + num] = playerId;
        changeDepth(tempDepth);
    }

    return (
        <div className='depth-chart-container'>
            {
                (positions && sortedPlayers && depth) &&
                <div className='depth-chart-content'>
                    <div className='depth-header'>Players:</div> 
                    <div className='player-list'>
                    {
                        positions.map((pos, index) => {
                            const defaultPlayer = players[depth[pos.id + '_0']];
                            if (!defaultPlayer) return;
                            return (
                                <div key={index} className='field small inline position-form'>
                                    <label>{pos.short}</label>
                                    <select
                                        value={defaultPlayer.id ?? ''}
                                        onChange={e => changeDepthChart(pos, 0, e.target.value)}>
                                        {
                                            sortedPlayers
                                            .map(p => {
                                                if (
                                                    Object.keys(depth).filter(k => 
                                                        k.includes("0") && 
                                                        !k.includes(pos.id) &&
                                                        depth[k] === p.id
                                                    ).length > 0
                                                ) return;
                                                return (
                                                    <option
                                                        key={p.id}
                                                        value={p.id}>
                                                        {p.fName} {p.lName} ({classLabel(p)}) - {positions[p.pos1 - 1].short} - Ovr {p.overall}{chemLabel(p)}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            )
                        })
                    }
                    </div>
                    <div className="g-space-1"></div>
                    <div className='depth-header'>Depth Chart</div>
                    <div className='player-list'>
                        {
                            positions.map(pos => {
                                
                                return (
                                    <div key={pos.id}>
                                        <div>{pos.long}</div>
                                        <div className='player-list'>
                                        {
                                            [2,3,4].map(id => {
                                                let depthId = pos.id + '_' + (id-1)
                                                return (
                                                    <div 
                                                        key={depthId}
                                                        className='field small inline'>
                                                        <label>{id}:</label>
                                                        <select
                                                            value={depth[depthId]}
                                                            onChange={(e) => changeDepthChart(pos, id-1, e.target.value)}
                                                            required >
                                                            <option value=''>None chosen...</option>
                                                            {
                                                                sortedPlayers
                                                                .map(p => {
                                                                    const key = RandomString(20);
                                                                    if (
                                                                        Object.keys(depth).filter(k => 
                                                                            !k.includes(id-1) &&
                                                                            k.includes(pos.id) &&
                                                                            depth[k] === p.id
                                                                        ).length > 0
                                                                    ) return;
                                                                    return (
                                                                        <option key={key} value={p.id}>
                                                                            {positions[p.pos1 - 1].short} - {p.fName} {p.lName} ({classLabel(p)}) - Ovr {p.overall}{chemLabel(p)}
                                                                        </option>
                                                                    )    
                                                                })
                                                            }
                                                        </select> 
                                                    </div>
                                                )
                                            })
                                        }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default DepthChartContainer